const legendText = {
  Wohnlage: {
    1: 'Einfache Wohnlage',
    2: 'Mittlere Wohnlage',
    3: 'Gute Wohnlage',
    4: 'Sehr gute Wohnlage',
    5: 'Top Wohnlage',
  },
  ÖPNV: {
    1: 'Geringe ÖPNV-Anbindung',
    2: 'Durchschnittliche ÖPNV-Anbindung',
    3: 'Gute ÖPNV-Anbindung',
    4: 'Sehr gute ÖPNV-Anbindung',
    5: 'Extrem gute ÖPNV-Anbindung',
  },
  Kultur: {
    1: 'Geringes Kulturangebot',
    2: 'Durchschnittliches Kulturangebot',
    3: 'Großes Kulturangebot',
    4: 'Sehr großes Kulturangebot',
    5: 'Extrem großes Kulturangebot',
  },
  Internet: {},
  Nahversorgung: {
    1: 'Geringe Nahversorgung',
    2: 'Durchschnittliche Nahversorgung',
    3: 'Gute Nahversorgung',
    4: 'Sehr gute Nahversorgung',
    5: 'Extrem gute Nahversorgung',
  },
};

export default legendText;
